<mat-form-field>
  <mat-label>Año</mat-label>
  <mat-select [(value)]="selectedYear" (selectionChange)="selectionChange()">
    <mat-option *ngFor="let year of years" [value]="year">{{
      year
    }}</mat-option>
  </mat-select>
</mat-form-field>
